// import axios from 'axios';
import { WebClientStore } from 'web-client-store';
var Cookie = WebClientStore.Cookie;
var AxiosSingleton = (function () {
    function SingletonClass() {
        return axios.create({ headers: { 'x-access-token': Cookie.get("__session") } });
    }
    var instance;
    return {
        getInstance: function () {
            if (instance == null) {
                instance = SingletonClass();
                // Hide the constructor so the returned object can't be new'd...
                instance.constructor = null;
            }
            return instance;
        }
    };
})();
export default AxiosSingleton;
/* Usage */
// let instance = AxiosSingleton.getInstance();
//# sourceMappingURL=AxiosSingleton.js.map